// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F1A4","right":"styles_right__37XhH"};